import { put, takeEvery, select, race } from 'redux-saga/effects';
import { startSubmit, stopSubmit, getFormValues, reset } from 'redux-form';
import { push } from 'connected-react-router';
import { notificationsAdd } from 'virtues-bootstrap';
import moment from 'moment';
import ReactGA from 'react-ga';

import { TIMING_CATEGORIES, TIMING_VARS } from 'services/googleAnalytics';

import { FORM_NAMES } from 'constants/forms';
import {
  requestCreatePatient,
  createPatient,
  requestCreatePatientFailure,
  patientSubmitEditForm,
  requestPutPatientById,
  requestPatientsResourceById,
  patientSubmitChangePasswordForm,
  requestPutChangePatientsPassword,
} from 'store/actionCreators/patient';
import { getUniqId } from 'utilities';
import i18n from 'services/i18n';
import { getCreatedPatientData, getEditedPatientData } from 'store/selectors/patient';

import { createSagaRace, createSagaRequestRace } from 'utilities/request';

export function* handleCreatePatient({ payload: { initTime } }) {
  try {
    yield put(startSubmit(FORM_NAMES.addPatient));

    const createdPatientData = yield select(getCreatedPatientData);

    yield put(requestCreatePatient(createdPatientData));

    const { success } = yield createSagaRace(requestCreatePatient);

    yield put(stopSubmit(FORM_NAMES.addPatient));

    if (success) {
      // TODO Probably should view modal with successfully result and redirect
      ReactGA.timing({
        category: TIMING_CATEGORIES.forms,
        variable: TIMING_VARS.addPatient,
        value: moment().diff(initTime),
      });
      yield put(push('/'));
    }

    return;
  } catch (error) {
    yield put(requestCreatePatientFailure(error));
  }
}

export function* handleSubmitEditForm() {
  yield put(startSubmit(FORM_NAMES.editPatient));
  const newPatient = yield select(getEditedPatientData);

  yield put(requestPutPatientById(newPatient));
  const { success } = yield race(createSagaRequestRace(requestPutPatientById));
  if (success) {
    yield put(requestPatientsResourceById({ patientId: newPatient.id }));
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'success',
        title: i18n.t('common:requestSuccess'),
        description: i18n.t('common:patient.successUpdateInfo'),
      }),
    );
  }

  yield put(stopSubmit(FORM_NAMES.editPatient));
}

export function* handleSubmitChangePassworsForm({ payload: { patientId } }) {
  yield put(startSubmit(FORM_NAMES.editPatientChangePass));
  const { password } = yield select(getFormValues(FORM_NAMES.editPatientChangePass));

  yield put(requestPutChangePatientsPassword({ patientId, password }));
  const { success } = yield race(createSagaRequestRace(requestPutChangePatientsPassword));
  if (success) {
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'success',
        title: i18n.t('common:requestSuccess'),
        description: i18n.t('common:patient.successChangePatientsPassword'),
      }),
    );
  }

  yield put(reset(FORM_NAMES.editPatientChangePass));
  yield put(stopSubmit(FORM_NAMES.editPatientChangePass));
}

export default function*() {
  yield takeEvery(createPatient, handleCreatePatient);
  yield takeEvery(patientSubmitEditForm, handleSubmitEditForm);
  yield takeEvery(patientSubmitChangePasswordForm, handleSubmitChangePassworsForm);
}
